/* eslint-disable react/no-danger */
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface PrimerAssemblyRowProps {
  binding: string;
  dg: string;
  finalized: boolean;
  fragmentResultColor: string;
  misprime: string;
  overhang: string;
  primerBases: string;
  primerName: string;
  showBinding: boolean;
  showHomology: boolean;
  showPrintableSummary: boolean;
  tmAnneal: number;
  tmDiff: number;
  tmWhole: number;
}

function PrimerAssemblyRow({
  binding,
  dg,
  finalized,
  fragmentResultColor,
  misprime,
  overhang,
  primerBases,
  primerName,
  showBinding,
  showHomology,
  showPrintableSummary,
  tmAnneal,
  tmDiff,
  tmWhole,
}: PrimerAssemblyRowProps): JSX.Element {
  return (
    <>
      <td
        style={{[showPrintableSummary ? 'borderLeftColor' : 'backgroundColor']: fragmentResultColor}}
        className="printable-color"
      >
        <a className="js-primer" {...getTestProps({component: 'PrimerAssemblyRow', element: 'primerName'})}>
          {primerName}
        </a>
      </td>
      {showPrintableSummary && <td dangerouslySetInnerHTML={{__html: primerBases}} />}
      <td className="tm text-center" {...getTestProps({component: 'PrimerAssemblyRow', element: 'tmWhole'})}>
        {tmWhole.toFixed(1)}
      </td>
      <td className="tm text-center">{tmAnneal.toFixed(1)}</td>
      <td className="tm text-center">
        <a className="js-pair">{tmDiff.toFixed(2)}</a>
      </td>
      {showBinding && <td className="binding text-center">{binding}</td>}
      {showHomology && <td className="homology text-center">{overhang}</td>}
      <td className="monomer text-center js-monomer" dangerouslySetInnerHTML={{__html: dg}} />
      {!finalized && (
        <td className="misprime text-center js-misprime" dangerouslySetInnerHTML={{__html: misprime}} />
      )}
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<PrimerAssemblyRowProps>(PrimerAssemblyRow);
